import React from 'react';
import ReactDOM from 'react-dom';
import Home from './components/home';


ReactDOM.render(
  <React.StrictMode>
    <Home />
  </React.StrictMode>,
  document.getElementById('root')
);


